
export function visibleWindow(windowVisible){
  return {
    type : windowVisible
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_window_visible500.js